/**
 * Shop facts and the strings that appear on more than one page.
 *
 * EDITING THIS FILE
 * -----------------
 * This is one of the copy modules — `app/frontend/lib/copy/*.ts`. Every visible
 * string on the redesigned pages lives in one of them, on purpose: Aaron's next
 * pass is a copy pass, and he should be able to change wording without opening
 * a component or touching layout.
 *
 * WHAT YOU MAY NOT DO HERE
 * ------------------------
 * Rewording is free. Asserting a NEW fact is not. Verified testimonial excerpts,
 * reviewer labels, and the Google rating snapshot live only in `reviews.ts` so
 * they retain one source and refresh date. Do not duplicate them here. Team
 * bios and founding years still require separate evidence. In particular: 2003
 * is when Ryan built his first cargo bike, NOT when the shop was founded —
 * "since 2003" on the shop is a fabricated founding date and it is one word
 * away in every draft.
 *
 * Ryan confirmed the current hours in person on 2026-08-25: Tuesday through
 * Saturday, 10am to 6pm. He expects they may change seasonally, so this remains
 * the single source for the current schedule.
 */

export const shop = {
  name: "Front Range Cargo Bikes",
  /** The masthead renders these two halves in different colors. */
  nameFirst: "Front Range ",
  nameSecond: "Cargo Bikes",

  phone: "303-263-6549",
  phoneHref: "tel:+13032636549",
  smsHref: "sms:+13032636549",
  email: "info@frontrangecargobikes.com",
  emailHref: "mailto:info@frontrangecargobikes.com",

  addressLine1: "2500 47th Street, Unit 12",
  addressLine2: "Boulder, CO 80301",
  /** The condensed form used in the slim sub-page footer. */
  addressShort: "2500 47th St Unit 12, Boulder",
  mapHref:
    "https://www.google.com/maps/dir/?api=1&destination=2500+47th+Street+Unit+12+Boulder+CO+80301&destination_place_id=ChIJ042p-N_ta4cRPwE3ImHrr-k",

  hoursOpen: "Tue–Sat · 10am–6pm",
  hoursClosed: "Closed Sun–Mon",
  hoursShort: "Tue–Sat 10–6",
  hoursFooter: "Tue–Sat, 10am–6pm",
} as const;

/** Primary routes. Visit details live on About and in every footer. */
export const nav = [
  { label: "Bikes", href: "/bikes" },
  { label: "Service", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Contact Us", href: "/contact" },
] as const;

/**
 * Two CTA destinations that appear on every page.
 *
 * Test rides use the live Cal.com event. Maintenance starts on the service
 * landing page because Ryan prefers a phone call or text before a bike comes
 * in; the bench is first come, first served rather than appointment-based.
 */
export const cta = {
  testRideLabel: "Schedule a test ride",
  testRideHref: "/book",
  maintenanceLabel: "Service & repairs",
  maintenanceHref: "/services",
  seeBikesLabel: "See the bikes",
  seeBikesHref: "/bikes",
} as const;
